import { Box, Typography } from "@mui/material";
import {useTranslation} from "react-i18next";
import {PAGE_APPLICATIONS} from "../../../locales/pages/namespaces";

export default function WarningBox() {
    const {t} = useTranslation(PAGE_APPLICATIONS)
    return (
        <Box
            sx={{
                width: 318,
                minHeight: 92,
                backgroundColor: "#FF5900",
                boxShadow: "0px 4px 14px rgba(0,0,0,0.1)",
                borderRadius: "9px",
                padding: "12px 24px",
                display: "flex",
                alignItems: "center",
            }}
        >
            <Typography
                sx={{
                    fontSize: 14,
                    fontWeight: 700,
                    lineHeight: "18px",
                    color: "#FFFFFF",
                }}
            >
                {t("Note")}
            </Typography>
        </Box>
    );
}
